export const LINK_DELETE_TOGGLE_LOADING = "LINK_DELETE_TOGGLE_LOADING";
